import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import {
	getAssets,
	saveEditAssets,
	saveAssetsFilters,
	deleteAsset,
	saveAssets
} from '../../../../redux/actions';

class ManageAssets extends Component {

	constructor(props) {
        super(props);
        this.state = {
			confirmationMessage: '',
			errorMessage: '',
			showResult: false,
			assetForm: {
				params: {
					accountType: '',
					assetType: '',
				},
				errors: {
					accountTypeError: '',
					assetTypeError: '',
				}
			}
        }
    }

	updateParams(formName, event) {
		//Reseting Errors on change
		const self = this;
		self.setState({
			confirmationMessage: '',
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[event.target.name]: event.target.value
				},
				errors: {
					...self.state[formName].errors,
					[event.target.name+'Error']: ''
				},
			},
			showResult: false
		});
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentWillMount() {
		const self = this,
			{ homepage, user: { userDetails } } = self.props.state,
			{ assets } = homepage;
		// redirect user to home page if he has not access to this page
		if(userDetails && !userDetails.isSiteManagementAccess) {
			browserHistory.push('/home');
		}
		//If there is no existing data available in store, then make service call and get data and then do needful
		if(!assets || !assets.responseObject) {
			self.props.getAssets(true, response => {
				if(!response.status) {
					browserHistory.push('/error');
				} else {
					self.setState({
						assets: JSON.parse(JSON.stringify(response))
					});
				}
			});
		} else {
			self.setState({
				assets: JSON.parse(JSON.stringify(assets.responseObject))
			});
		}
	}

	handleSubmit(event) {
		const self = this;
		const { params, errors } = self.state.assetForm;
		let formError = false;
		//Reset all errors
		for(var key in errors) {
            if(!params[key.replace("Error","")]) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }
		self.setState({
			params,
			errors
		});

		if(!formError) {
			const fitlerData = [];
			let assets = JSON.parse(JSON.stringify(self.props.state.homepage.assets));
			const { params: { accountType, assetType} } = self.state.assetForm;
			assets.responseObject.forEach(item => {
				if(item.assetType === assetType && item.customerType === accountType) {
					fitlerData.push(item);
				}
			});

			self.setState({
				showResult: true,
				assets: JSON.parse(JSON.stringify(fitlerData))
			});
		}
	}

	handleCreateAsset(event) {
		event.preventDefault();
		const self = this;
		self.props.saveAssetsFilters(self.state.assetForm.params);
		browserHistory.push('/siteManagement/asset/create');
	}

	handleEditAsset(assetData, event) {
		event.preventDefault();
		const self = this;
		self.props.saveEditAssets(assetData);
		browserHistory.push('/siteManagement/asset/edit');
	}

	handleDeleteAsset(assetData, index, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			confirmationMessage: '',
			deletingAssetData: assetData
		}, () => {
			self.props.deleteAsset(assetData, '', response => {
				if(response.status && response.responseObject) {
					const { assets } = JSON.parse(JSON.stringify(self.props.state.homepage));
					assets.responseObject = assets.responseObject.filter(item => item.assetId !== self.state.deletingAssetData.assetId);
					self.props.saveAssets(assets);
					self.setState({
						confirmationMessage: 'Asset has been successfully deleted.',
						assets: self.state.assets.filter(item => item.assetId !== self.state.deletingAssetData.assetId)
					});
				} else {
					browserHistory.push('/error');
				}
			});
		});
	}

    render() {
		const self = this;
		const { state, state: { showResult } } = self;
		const { assets } = self.state;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">Home Page Assets</h1>
				</div>
				{this.state.errorMessage?<p className="red bold push">{this.state.errorMessage}</p>:null}
				<div className="push">
					<p className="bold red" id="errorMessage">{this.state.errorMessage}</p>
					<table style={{width: '100%'}} className="formTableTypeA createOrderTableA">
						<tbody>
							<tr>
								<td style={{textAlign: 'left'}}>Account Type</td>
								<td>
									<select className={state.assetForm.errors.accountTypeError} name="accountType" onChange={this.updateParams.bind(this, 'assetForm')}>
										<option value="">-- Select Account Type --</option>
										<option value="Retail">Retail</option>
										<option value="Contract">Contract</option>
										<option value="PRO CHANNEL">Pro</option>
										<option value="Parts">Parts</option>
									</select>
								</td>
							</tr>
							<tr>
								<td style={{textAlign: 'left'}}>Asset Type</td>
								<td>
									<select className={state.assetForm.errors.assetTypeError} name="assetType" onChange={this.updateParams.bind(this, 'assetForm')}>
										<option value="">-- Select Asset Type --</option>
										<option value="RotatingBanner">Rotating Banners</option>
										<option value="MarketingSlot">Marketing Slots</option>
									</select>
								</td>
							</tr>
							<tr>
								<td />
								<td>
		                            <input type="button" onClick={this.handleSubmit.bind(this)} className="blueButton uppercase" defaultValue="Submit" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="push">
					{showResult && assets &&
						<div>
							{this.state.confirmationMessage && <p className="bold red">{this.state.confirmationMessage}</p>}
							<table className="dataTable savedBrochuresTable savedBrochuresASMTable">
					          	<thead>
						            <tr>
						              	<th className="brochureName">
						                	Asset Name
										</th>
										<th className="startDate" >
						                	Start Date
						              	</th>
										<th className="endDate">
						                	End Date
						              	</th>
										<th className="priority" style={{textAlign: 'center'}}>
						                	Priority
						              	</th>
										<th className="editBrochure" style={{textAlign: 'center'}}>
						                	Edit Asset
						              	</th>
										<th className="deleteBrochure" style={{textAlign: 'center'}}>
						                	Delete Asset
						              	</th>
						            </tr>
					          	</thead>
					          	<tbody>
									{assets.length === 0
										?<tr>
											<td className="brochureName" colSpan={3}>
												No assets found.
											</td>
										</tr>
										:null
									}
									{assets.map((item, index) => {
										return <tr key={index+1}>
							              	<td className="brochureName">
							                	{item.assetName}
												</td>
											<td className="startDate">
							                	{item.createdDate}
							              	</td>
											<td className="endDate">
							                	{item.endDate}
							              	</td>
											<td className="priority" style={{textAlign: 'center'}}>
							                	{item.priority}
							              	</td>
											<td className="editBrochure text-center">
							                	<a className="editBrochureIcon" href="" onClick={this.handleEditAsset.bind(this, item)}>
													<img src="../images/icon-edit-brochure-large.png" width={26} height={21} alt="Edit Asset" title="Edit Asset" />
												</a>
							              	</td>
											<td className="deleteBrochure text-center">
												<a className="deleteBrochureLink" href="" onClick={this.handleDeleteAsset.bind(this, item, index)}>✗</a>
											</td>
							            </tr>
									})}
					          	</tbody>
					        </table>
							<p className="textRight">
								<input type="button" onClick={this.handleCreateAsset.bind(this)} className="blueButton uppercase" defaultValue="Create Asset" />
							</p>
						</div>
					}
					<p>
						<Link to="/siteManagement">Back to Site Management</Link>
					</p>
				</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getAssets: (showLoader, callback) => dispatch(getAssets(showLoader, callback)),
	deleteAsset: (payload, queryStringParams, callback) => dispatch(deleteAsset(payload, queryStringParams, callback)),
	saveAssetsFilters: (data) => dispatch(saveAssetsFilters(data)),
	saveEditAssets: (data) => dispatch(saveEditAssets(data)),
	saveAssets: (data) => dispatch(saveAssets(data)),
});

ManageAssets = connect(mapStateToProps, mapDispatchToProps)(ManageAssets);
export default ManageAssets;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/ManageAssets/index.js